export { default as PickTicketDetailListTemplate } from './PickTicketDetailListTemplate';
